/**
 * Google Analytics 4 funnel events (the gtag snippet is added by vite.brand.ts
 * when brand.json has gaMeasurementId). Events carry no personal data: no
 * email, name, phone, user id or payment reference, only the event name and
 * plan-level values. A missing or blocked gtag is a silent no-op.
 *
 * Mark these as key events in GA4 (docs/seo-plan.md, "Google Analytics 4"):
 * sign_up, begin_checkout, payment_submitted.
 */
type Params = Record<string, string | number | boolean>;

declare global {
  interface Window {
    gtag?: (command: "event", name: string, params?: Params) => void;
  }
}

export function track(name: string, params: Params = {}): void {
  try {
    window.gtag?.("event", name, params);
  } catch {
    // analytics must never break the page
  }
}
